
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form, Container} from "react-bootstrap";
import { hydrateRoot } from 'react-dom/client';
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus,ArrowUp, Pencil,CrosshairSimple   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import {formatDate, generateId, isNumeric} from "../utils/functions";
import EditNow from "../components/EditNow";
import QuickAnnotation from "../components/QuickAnnotation";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import clickableMarker from "../utils/clickableMarker";
import * as yup from 'yup';
import * as formik from 'formik';
import schemas from "../data/dataSchemas";
import * as React from 'react';



const { Formik } = formik;

class ToolAnnotation {

	annotationIcon = '<svg class="lines" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><line x1="96" y1="112" x2="160" y2="112" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="96" y1="144" x2="160" y2="144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>';
	annotationDot = ' <svg class="circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><circle r="45" cx="60" cy="60" fill="currentColor" /></svg> ';
	
	tabIndex			= null;
	highlightedOnList	= [];
	hiddenAnnotations		= [];
	allHidden			= false;
	currentAnnotation	= null;
	
	modified			= false;
	
	ADD					= 1;
	REMOVE				= 2;
	
	_noteIconSize		= {x:30,y:30};
	
	constructor(p) {
		if(p){
			this.tc = p;
			this.parent = p;
		}
		if (!ToolAnnotation.annotations){
			ToolAnnotation.annotations		= [];
			ToolAnnotation.tabIndex		= null;
		}
		
		
	}
	id(id){
		return 'annotation-marker'+id;
	}
	setAddAnnotationListener = ()=>{
		this.parent.map.getContainer().classList.add("cursor-add-annotation");
		this.parent.map.on('click', this.addAnnotation);
	}
	remAddAnnotationListener = ()=>{
		this.parent.map.getContainer().classList.remove("cursor-add-annotation");
		this.parent.map.off('click', this.addAnnotation);
	}
	addOutsideClickListener = ()=>{
		this.parent.map.on('click', this.handleClickOutside);
	}
	remOutsideClickListener = ()=>{
		this.parent.map.off('click', this.handleClickOutside);
	}
	update(){
		

	}
	init(){
		this.display();
		this.drawAnnotations();
		this.setEventHandlers();
	}
	exit(){
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(ToolAnnotation.tabIndex);
		ToolAnnotation.tabIndex = null;
		this.removeEventHandlers();
		this.closeAnnotation(true);
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		
		this.setAddAnnotationListener();
		this.setDragListener();
		this.parent.map.on('contextmenu', this.handleRightClick);
		
	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		
		this.parent.map.off('contextmenu', this.handleRightClick);
		this.parent.map.off('click', this.removeAnnotation);
		this.parent.map.off('click', this.addAnnotation);
		this.remOutsideClickListener();
		this.remAddAnnotationListener();
		this.remDragListener();
		this.parent.map.getContainer().classList.remove("cursor-add-annotation");
		
	}
	setDragListener = () => {
		ToolAnnotation.annotations.forEach((m)=>{
			m._element.addEventListener("mousedown",	this.handleMouseDown);
		});
	}
	
	remDragListener = () => {
		ToolAnnotation.annotations.forEach((m)=>{
			m._element.removeEventListener("mousedown",	this.handleMouseDown);
		});
	}
	addAnnotation = (e)=>{
		if(this.parent.secondaryHandler)
			return;
		
		if(this._dragging){
			delete this._dragging;
			return;
		}
		
		this.closeContextMenu();
		if(e.originalEvent.target.closest(".annotation-marker"))
			return; //avoid placing annotations where we already have one
		
		e.originalEvent.stopPropagation();
		
		this.remAddAnnotationListener();
		this.addOutsideClickListener();
		
		var newAnnotation = {
			"id":generateId(),
			"lon": e.lngLat.lng,
			"lat": e.lngLat.lat,
			"project_id": this.parent.scenario.projectid,
			"scenario_id": this.parent.scenario.scenario_id,
			"type": "note",
			"text": "",
			"timestamp": (new Date()).toISOString()
		}
		const {marker, elem} = this.drawAnnotation(newAnnotation);
		elem.classList.toggle("active");
		this.currentAnnotation = marker;
		
		//reset drag listeners
		this.remDragListener();
		this.setDragListener();
		
		ReactDOM.createRoot(elem.querySelector(".annotation-text-wrp")).render(
			this.addAnnotationText(
				newAnnotation,
				/* on save do next */
				(data)=>{

					var newScenario = structuredClone(this.parent.scenario);
					newScenario.annotations.push(data);
					this.parent.setScenario(newScenario);

					elem.dataset.annotationid = data.id;
					elem.id = this.id(data.id);
					this.setAddAnnotationListener();
					
					this.remOutsideClickListener();
					this.display();
				}
		));
		setTimeout(()=>{
			elem.querySelector("textarea").focus();
		}, 100);
	
		
//		let event = {
//			scenario:this.parent.scenario, 
//			annotation:newAnnotation
//		};
//		this.parent.map.fire("addAnnotation", event);
//		
	}
	closeAnnotation = (exitMode) => {
		if(this.currentAnnotation){
			/* if not saved yet */
			if(!isNumeric(this.currentAnnotation._element.dataset.annotationid) /* && !this.currentAnnotation._element.querySelector("textarea").value.length*/){
				this.currentAnnotation.remove();
				this.currentAnnotation = null;
			}
			else {
				this.currentAnnotation._element.classList.toggle("active");
				this.currentAnnotation = null;
			}
				
				
		}
		if(!exitMode)
			this.setAddAnnotationListener();
		
		this.remOutsideClickListener();
	}
	removeAnnotation = (e, aId) =>{
		
		e?.originalEvent?.stopPropagation();
		var	annotationId;
		
		if(aId){
			annotationId = aId;
		}
		else {
			var elem = e.originalEvent.target.closest(".annotation-marker");
			
			annotationId = elem.dataset.annotationid;
		}	
		if(!annotationId)
			return
		
		var an = this.parent.scenario.annotations.find((a)=>{return a.id == annotationId});
		
		if(an && isNumeric(an.id)){
			vindrApi.deleteAnnotations(an.project_id, an.scenario_id, an.id).then((res)=>{
				
				const idx = this.parent.scenario.annotations.find((a)=>{return a.id == annotationId});
				var newScenario = structuredClone(this.parent.scenario);
				newScenario.annotations.splice(idx, 1);
				this.parent.setScenario(newScenario);
				
				this.delAnnotation(annotationId);
			});
		}
		else{
			this.delAnnotation(annotationId);
		}
		
		this.display();
	}
	delAnnotation(id){
		
		var idx = ToolAnnotation.annotations.findIndex((a)=>{return a._element.dataset.annotationid == id});
		
		if(idx == -1)
			return;
		
		ToolAnnotation.annotations[idx].remove();
		ToolAnnotation.annotations.splice(idx, 1);
	}

	addAnnotationText(annotation, onFinish, edit){
		
		

		return (
	
				<QuickAnnotation context={this.parent.draw.context} edit={edit} annotation={annotation} onFinish={onFinish ? onFinish : null}  />
			
		);
		
	}
	addAnnotationTextWrp(annotationid){
		
		var input = document.createElement('div');
		input.className = "annotation-text-wrp";
		return input;
		
	}

	handleKeyPress = (e)=>{
		e.stopPropagation();
	}
	drawAnnotations(tc, newScenario){
		
		var scenario = this.parent.scenario;
		
		this.clearAnnotations();
		
		scenario.annotations.forEach(this.drawAnnotation);	
	}
	drawAnnotation = (annotation)=>{
		const el = document.createElement('div');
		el.className = 'annotation-marker';
		el.id = this.id(annotation.id);
		el.dataset.annotationid = annotation.id;
		var drop = document.createElement('div');
		drop.className="drop";
		drop.innerHTML = this.annotationIcon + this.annotationDot;

		const marker = new clickableMarker({
			draggable: true,
			element:el,
			anchor:'bottom-left'
		})
		.noListeners()
		.setLngLat([annotation.lon, annotation.lat]);
	
		marker._element.appendChild(this.addAnnotationTextWrp(annotation));
		marker._element.appendChild(drop);
		marker._element.addEventListener("click",		this.handleAnnotationClick);
		marker._element.addEventListener("mouseenter",	this.handleAnnotationEnter);
		marker._element.addEventListener("mouseleave",	this.handleAnnotationLeave);
		
	
		
		marker.addTo(this.parent.map);

		ToolAnnotation.annotations.push(marker);
		
		return {marker:marker, elem:marker._element};
	}
	handleMouseDown = (e)=>{
		
		const annotationid = e.currentTarget.dataset.annotationid
		this.dragAnnotation = ToolAnnotation.annotations.find((a)=>{return a._element.id == this.id(annotationid)});
		
		if(this.dragAnnotation._element.classList.contains("active"))
			return;
		
		this.dragAnnotation._element.addEventListener("mouseup",	this.handleMouseUp);
		
		this.tc.map.on("mousemove", this.handleMouseMove);
		
		this.dragOffset = {x:this._noteIconSize.x-e.offsetX, y:this._noteIconSize.y-e.offsetY};
	}
	
	handleMouseMove = (e)=>{
		
		this._lngLat = this.tc.map.unproject({x:e.point.x-this.dragOffset.x, y: e.point.y+this.dragOffset.y});
		
		this.dragAnnotation.setLngLat(this._lngLat);
		
		this._dragging = true;
		
	}
	handleMouseUp = (e)=>{
		this.tc.map.off("mousemove", this.handleMouseMove);
		if(this.dragAnnotation){
			this.dragAnnotation._element.removeEventListener("mouseup",	this.handleMouseUp);
			this.handleAnnotationMove(this.dragAnnotation);
		}
		this.dragAnnotation = null;
		this.dragOffset = null;
	}
	
	handleAnnotationClick = (e)=>{
		
		if(this._dragging){
			delete this._dragging;
			return;
		}
		e.stopPropagation();
		if(!e.target.closest(".drop"))
			return;
		
		var elem = e.target.closest(".annotation-marker");
		
		var id = elem.dataset.annotationid;
		
		if(!isNumeric(id))
			return;
		
		const active = elem.classList.toggle("active");
		if(!active){
			elem.querySelector(".quickannotation").remove();
			return;
		}
		const an = this.parent.scenario.annotations.find((a)=>{return a.id == id});
		
		if(elem.querySelector(".quickannotation"))
			return;
		ReactDOM.createRoot(elem.querySelector(".annotation-text-wrp")).render(this.addAnnotationText(an, null, (e.x ? false:true)));
		
		if(this.isAllShowing()){
			this.setExpandToggle(true);
		}
		
		
	}
	handleClickOutside = ()=>{
		this.closeAnnotation();
	}
	handleAnnotationMove = (annotation)=>{
		
		var coords = annotation.getLngLat();
		
		
		const an = this.tc.scenario.annotations.find((a)=>{return a.id == annotation._element.dataset.annotationid});
		
		an.lat = coords.lat;
		an.lon = coords.lng;
		
		vindrApi.updateAnnotations(this.tc.scenario.projectid, this.tc.scenario.scenario_id, an);
		
	}
	clearAnnotations(){
		ToolAnnotation.annotations.forEach((s) => {
			s.remove();
		});
		ToolAnnotation.annotations = [];
	}
	handleAnnotationEnter = (e) => {
		e.stopPropagation();
		
		if(!this.parent.handler || this.parent.handler.constructor.name != 'ToolAnnotation'){
			return;
		}
		
		const annotationId = e.target.dataset.annotationid;
		
		this.highlightOnList(annotationId);
		
	}
	handleAnnotationLeave = (e) => {
		e.stopPropagation();
		
		if(!this.parent.handler || this.parent.handler.constructor.name != 'ToolAnnotation'){
			return;
		}
		
		const annotationId = e.target.dataset.annotationid;
		
		this.deHighlightOnList(annotationId);
		
	}
	highlightOnMap = (row) => {
		document.getElementById(this.id(row.id))?.classList?.add("hover");
	}
	
	deHighlightOnMap = (row) => {
		document.getElementById(this.id(row.id))?.classList?.remove("hover");
	}
	
	idString(id){
		return isNaN(id) ? id : id.toString();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];

		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(this.idString(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}
	
	
	handleRowClick = (row)=>{
		
		this.handleEditAnnotation(null, row.id);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
	
	closeContextMenu = ()=>{
		
		
		document.removeEventListener("click", this.closeContextMenu);
		
		if(!this.parent)
			return;
		var a = false;
		if(a = this.parent.map.getContainer().querySelector(".annotationModeContextMenu")){
			a.remove();
		}
		
		
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		if(!e.originalEvent.target.closest(".annotation-marker"))
			return; //avoid placing annotations where we already have one
		
		const el = e.originalEvent.target.closest(".annotation-marker");
		
		var wrp = document.createElement("div");
		wrp.className = "annotationModeContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		this.parent.map.getContainer().appendChild(wrp);
		
		this.addMapClickClose();
		ReactDOM.createRoot(wrp).render(this.contextMenu(e, el.dataset.annotationid));
		
	}
	addMapClickClose(){
		
		document.addEventListener("click", this.closeContextMenu);
	}
	handleExpandAll = (e) => {
	
		const show = e.target.checked;
		
		ToolAnnotation.annotations.forEach((m)=>{

			if((show && m._element.classList.contains('active')) || (!show && !m._element.classList.contains('active')))
				return;
			
			m._element.querySelector(".drop").click();
			
		});
	}
	
	handleHideAllAnnotations = () => {
		if(!this.allHidden){
			this.hiddenAnnotations = this.parent.scenario.annotations.map((t)=>{
				this.handleToggleAnnotation(t.id, true, true);
				return t.id;
			});
			this.allHidden = true;
		}
		else{
			const ans = structuredClone(this.hiddenAnnotations);
			ans.forEach((t)=>{this.handleToggleAnnotation(t, false, true);});
			this.allHidden = false;
			
		}
		this.display();
	}
	handleToggleAnnotation = (annotationid, force, dontRefresh) => {
		
		
		const hidden = document.getElementById("annotation_"+annotationid).classList.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		if(!hidden){
			const index = this.hiddenAnnotations.indexOf(annotationid);
			if (index > -1) {
			  this.hiddenAnnotations.splice(index, 1);
			}
		}
		else
			this.hiddenAnnotations.push(annotationid);
		
		if(!hidden){
			this.allHidden = false;
//			this.parent.scenario.annotations.map((t)=>{
//				if(t.id != annotationid)
//					this.handleToggleAnnotation(t.id, true, true);
//				
//			});
		}
		if(!this.hiddenAnnotations.length){
			this.allHidden = false;
		}
		if(this.hiddenAnnotations.length == this.parent.scenario.annotations.length){
			this.allHidden = true;
		}
		
		var global = document.getElementById(this.id(annotationid)).classList.toggle("d-none", hidden);
		
			
		if(!dontRefresh)
			this.display();
		
	}

	handleRemoveAnnotation = (e, annotationId) => {
		this.removeAnnotation(e, annotationId);
		this.display();
		return true;
	}
	handleSelect = (e, row) => {
		const id = "id";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;
		this.selected.forEach((row) => {
			this.removeAnnotation(null, row.id);
		});
		this.selected = [];
		this.display();
	}
	handleUpdateName(newName, id){
		this.updateAnnotationName(newName, id, true);
		this.display();
	}
	handleEditAnnotation(e, annotationid){
		
		
		document.getElementById(this.id(annotationid)).querySelector('.drop').click();
		
		
		this.currentAnnotation = ToolAnnotation.annotations.find((a)=>{return a._element.id == this.id(annotationid)});
		
		this.remAddAnnotationListener();
		this.addOutsideClickListener();
	}
	handleZoomAnnotation = (anId)=>{

		const an = this.parent.scenario.annotations.find((a)=>{return a.id == anId});

		this.parent.map.resize(); //if we don't do this sometimes there will be offset in the the center
		this.parent.map.flyTo({
			center:[an.lon, an.lat] ,
			speed: 1.2,
			zoom: 14
		});


	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.idString(row.id));
	}
	isAllShowing= () => {
		
		var res = true;
		ToolAnnotation.annotations.forEach((m)=>{
			if(!m._element.classList.contains('active'))
				res	= false;
		});
		return res;
	}
	setExpandToggle(val){
		if(document.getElementById('expand-all'))
			document.getElementById('expand-all').checked = val;
	}
	display(){
		if(this.parent.serviceBar.current)
			ToolAnnotation.tabIndex =	this.parent.serviceBar.current.inject(this.render(), ToolAnnotation.tabIndex);
	}
	
	contextMenuEdit(map_event, annotationId){
		return (
			<button className="btn" onClick={(e)=>{this.handleEditAnnotation(e,); this.closeContextMenu();}}><Plus size={20} /> Edit Annotation</button>
		);
	}
	contextMenu(map_event, annotationId){
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditAnnotation(map_event, annotationId); this.closeContextMenu();}}><Pencil size={20} /> Edit annotation</button>
				<button className="btn" onClick={(e)=>{this.handleZoomAnnotation(annotationId); this.closeContextMenu();}}><CrosshairSimple  size={20} /> Zoom to annotation</button>
				<button className="btn" onClick={(e)=>{this.removeAnnotation(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove annotation</button>
			</>
		);
	}
		
	render(){
		
		//this.allHidden = this.parent.map.getContainer().classList.contains("hide-annotations");
		
		var annotations = this.parent.scenario.annotations ? this.parent.scenario.annotations.filter((a)=>{return !!a.text}) : [];
		return (
			<>
				<div className={"project-annotations "}>
					<div className="title">
						Annotations
						{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>*/}
					</div>
					<div className="scroll">
						<div className="content p-0">

							<DataTable
								data={annotations}
								columns={
									[
										{
											name:<Eye onClick={this.handleHideAllAnnotations} className={""+(this.allHidden ? 'opacity-25' : '')} size={16} />,
											id:'userid',
											selector: row => row.userid,
											format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleAnnotation(row.id, undefined, false)}} id={"annotation_"+row.id} data-id={row.id}  className={""+(this.hiddenAnnotations.includes(row.id) || this.allHidden ? 'opacity-25' : '')} size={16} />),
											style: {
												padding: '0',
												maxWidth:"28px !important",
											}
										},
										{
											name:'',
											selector: row => row.text,
											format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.id} checked={this.selected && this.selected.some((a)=>a.id == row.id)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
											width:"25px",
											style: {
												padding: '0px !important',
												width:'25px'
											}
										},
										{
											name:'Annotation',
											selector: (row) => (row.text),
											format: (row,index) => (row.text),
											sortable:true,
											width:"195px",
											//maxWidth:"160px !important",
										},
										{
											name:'Date',
											selector: (row) => {return row.timestamp},
											format: (row,index) => (formatDate(row.timestamp, 'short')),
											sortable:true,
											width:"80px",
											center: "true",
											//maxWidth:"160px !important",
										},
										{
											name:'',
											cell: row => (
												<div className="context-menu" data-tag="allowRowEvents">
														<Dropdown className="minimal">
															<Dropdown.Toggle className="p-0 px-1" variant="default">
																<DotsThreeVertical size={16} />
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditAnnotation(e, row.id);   }}><PencilSimple size={16} /> Edit annotation</Dropdown.Item>
																<Dropdown.Item href="#" onClick={(e)=>{this.handleZoomAnnotation(row.id);}}><CrosshairSimple  size={16} /> Zoom to annotation</Dropdown.Item>
																<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveAnnotation(e, row.id); }} className="text-danger" ><Trash size={16} /> Remove annotation</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
												</div>
											),
											style: {
												maxWidth:"20px !important"
											}
											
											//minWidth:"160px !important",
											//maxWidth:"160px !important",
										}
									]
								}
								customStyles={{
									headCells:{
										style: {
											padding:'.5rem .3rem',
											minWidth:'0px !important',
											boxSizing:'content-box',
											fontWeight:'bold'
										}
									},
									cells:{
										style: {
											padding:'.5rem .3rem',
											minWidth:'0px !important',
											boxSizing:'content-box',
											fontSize: 'var(--bs-body-font-size);',
											color:'var(--bs-body-color)',
											'&:last-child':{paddingRight:'1rem'}
										}
									},
									rows:{
										style: {
											minHeight:"0",
										},
										selectedHighlightStyle:{
											backgroundColor:'red'
										}
									}
								}}
								onRowMouseEnter={this.highlightOnMap}
								onRowMouseLeave={this.deHighlightOnMap}
								onRowClicked={this.handleRowClick }
								selectableRowSelected={r=>this.isSelectedOnList(r)}
								highlightOnHover
								selectableRowsHighlight
								pointerOnHover
								sortIcon={<i className="ri-expand-up-down-line" />}
								noDataComponent={

									<Row className="p-0 py-3 m-0">

										<Col xs="1 pe-0">
											<Info className="text-danger" size={15} />
										</Col>
										<Col xs="11 ps-0">
											<b>Please note:</b> There are currently no annotations placed in this scenario.
										</Col>



									</Row>
								}
							/>
							{this.selected && !!this.selected.length &&
								<Row className="p-3 batch-action">
									<Col xs="6">
										{this.selected.length} Items selected
									</Col>
									<Col xs="6 text-end">
										<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
									</Col>
								</Row>
							}
						</div>

					</div>

				</div>	
				<Container>
					<Row className="status-switch">	
						<Col xs="12">
							<Form.Check id={"expand-all"} value="1" onClick={this.handleExpandAll} type="switch" defaultChecked={false} /> Expand all annotations
						</Col>
					</Row>
				</Container>
			</>
		);
		
	}
}

export default ToolAnnotation;